import { Zap, Heart, BarChart3, Sparkles } from 'lucide-react';
import ChooseUsImage from "@/assets/images/aisolution/why-choose-us.webp";
const aiFeatures = [
    { icon: Zap, text: "Unlocking Efficiency with AI" },
    { icon: Heart, text: "Enhancing Customer Experiences" },
    { icon: BarChart3, text: "Data-Driven Insights for Smarter Decisions" },
    { icon: Sparkles, text: "AI for Innovation and Growth" }
];

export default function WhyChooseUs() {
	return (
		<section className="pt-16 text-white">
			<div className="container">
				<div className="grid lg:grid-cols-2 gap-12 items-center mb-24 md:mb-32">
					<div className="lg:order-1 order-2">
						<h3 className="text-lg text-gray-300 mb-3">Why Choose Us</h3>
						<h2 className="text-3xl md:text-4xl font-bold mb-8">
							Take the Leap into AI Innovation
						</h2>

						<div className="grid grid-cols-1 md:grid-cols-1 gap-4">
							{aiFeatures.map((feature, index) => {
								const Icon = feature.icon;
								return (
									<div 
										key={index}
										className="group flex items-center gap-4 bg-gradient-to-br from-purple-600/5 to-blue-600/5 border border-purple-500/20 p-4 rounded-lg hover:border-purple-500/50 hover:bg-gradient-to-br hover:from-purple-600/10 hover:to-blue-600/10 transition-all duration-300"
									>
										<div className="bg-gradient-to-r from-purple-600 to-blue-600 p-4 rounded-lg group-hover:scale-110 transition-transform duration-300">
											<Icon size={26} className="text-white" />
										</div>
										<span className="text-lg text-white">{feature.text}</span>
									</div>
								);
							})}
						</div>
					</div>

					<div className="lg:order-2 order-1 relative">
						<img
							src={ChooseUsImage}
							alt="Team meeting"
							className="w-full h-auto rounded-3xl"
						/>
					</div>
				</div>
			</div>
		</section>
	);
}